import {
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from "libphonenumber-js/max"
import { z } from "zod"
import { TranslationKey } from "../i18n/translation-key"

export const phoneNumberSchema = () =>
  z
    .string({
      error: "common.validation.phoneRequired" satisfies TranslationKey,
    })
    .refine((val) => isValidPhoneNumber(val), {
      message: "common.validation.invalidPhone" satisfies TranslationKey,
    })

/** Parses a phone number in any common format (national numbers default to
 * Sweden) to E.164, or returns null when it isn't a valid number. */
export const toE164PhoneNumber = (phoneNumber: string): string | null => {
  const parsed = parsePhoneNumberFromString(phoneNumber, "SE")
  if (!parsed?.isValid()) {
    return null
  }
  return parsed.number
}

const normalizePhoneNumber = (phoneNumber: string): string =>
  toE164PhoneNumber(phoneNumber) ?? phoneNumber.replace(/[\s-]/g, "")

/** Whether two numbers reach the same phone, however each one is formatted
 * ("070-123 45 67" and "+46701234567" match). Empty numbers never match. */
export const isSamePhoneNumber = (
  a: string | null | undefined,
  b: string | null | undefined,
): boolean => {
  if (!a || !b) {
    return false
  }
  return normalizePhoneNumber(a) === normalizePhoneNumber(b)
}
